import { partnersService } from "Dashboard/scenes/Partners/services/partner.service";
import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { IOption } from "Dashboard/domain/IOption";
import { useAppDispatch } from "hooks/hooks";
import { setPartners, setSelectedPartnerId } from "../../Stock/secenes/Input/inputSlice";

const PartnerSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const { value, setValue } = props;
  const [valueLocal, setValueLocal] = useState<IOption | undefined>(undefined);
  const dispatch = useAppDispatch();

  useEffect(() => {
    async function getData() {
      const data = await partnersService.getAllPartners();
      dispatch(setPartners(data.partners));
      const op = data.partners.map((partner) => {
        return {
          label: partner.shortName,
          value: partner.partnerId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      if (props.options) {
        setOptions(props.options);
      } else {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }, [props.options]);

  useEffect(() => {
    if (props.defaultValue) {
      const values = options.filter((o) => o.value === props.defaultValue);
      if (values[0]) {
        setSelectedPartner(values[0]);
      } else setValueFunction(undefined);
    }
  }, [options, props.defaultValue]);

  const getValue = () => {
    if (value) {
      const values = options.filter((o) => o.value === value);
      if (values[0]) {
        return values[0];
      }
    }
    return valueLocal;
  };

  const setValueFunction = (option: IOption | undefined) => {
    if (setValue) {
      setValue(option?.value);
    }
    setValueLocal(option);
  };

  const setSelectedPartner = (newValue: any) => {
    setValueFunction(newValue);
    dispatch(setSelectedPartnerId(newValue ? newValue.value : undefined));
  };

  const handleChange = (newValue: any, actionMeta: any) => {
    setSelectedPartner(newValue);
    props.onChange && props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      isClearable
      menuPosition="fixed"
      styles={props.customStyles}
      ref={ref}
      options={options}
      value={getValue()}
      onChange={handleChange}
      placeholder={props.placeholder ? props.placeholder : ""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default PartnerSelect;
